import React, { useState } from "react";
import Loginlogo from "./Common/Loginlogo";
import { useDispatch } from "react-redux";
import { NewPasswordAction } from "../Redux/action/AuthAction";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Button from "@mui/material/Button";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ebenchLogo from "../images/ebench_logo.png";
import { IoMdEye, IoMdEyeOff } from "react-icons/io";

const NewPassword = () => {
  const [state2, setState] = useState({
    password: "",
    confirm_password: "",
  });
  const { state } = useLocation();
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  console.log("state1", state);
  const [mess, setMess] = useState("");
  const dispatch = useDispatch();
  const { password, confirm_password } = state2;
  const candidateId = state?.candidateId;
  const vendorId = state?.vendorId;
  const userType = state?.userType;

  const handleInputChange = (e) => {
    setMess("");
    const { name, value } = e.target;
    setState({ ...state2, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password === confirm_password) {
      setMess("");
      if (userType == "CANDIDATE") {
        const content = {
          password,
          candidateId,
          userType,
        };
        dispatch(NewPasswordAction(content)).then((res) => {
          // console.log("rrss",res);
          if (res?.data) {
            navigate("/login"); 
          }
        });
      } else {
        const content = {
          password,
          vendorId,
          userType,
        };
        dispatch(NewPasswordAction(content)).then((res) => {
          // console.log("rsrs",res);
          if (res?.data) {
            setTimeout(() => {
              navigate("/login");
            }, 1000);
          }
        });
      }
    } else {
      setMess("Password Did Not Match");
    }
  };

  return (
    <>
      <ToastContainer />
      <header
        className="d-flex justify-content-between align-items-center px-5 py-3 shadow-sm"
        style={{ backgroundColor: "#fff" }}
      >
        {/* Logo */}
        <div className="landing_logo">
          <Link to="/">
            <img
              src={ebenchLogo}
              alt="Ebench Logo"
              className="responsive-logo-of-without-login"
            />
          </Link>
        </div>

        {/* Menu Items */}
        <div className="landing_menu_items d-flex align-items-center gap-3">
          <Link to="/login">
            <button
              className="btn btn-outline-primary-custom"
              style={{ padding: "6px 20px", fontWeight: 600 }}
            >
              Login
            </button>
          </Link>
        </div>
      </header>

      <div
        style={{
          width: "100%",
          minHeight: "90vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "0 16px", // Adds horizontal spacing on small screens
          backgroundColor: "#f5f5f5", // Optional background
        }}
      >
        <div
          style={{
            width: "100%",
            maxWidth: "400px",
            backgroundColor: "white",
            borderRadius: "10px",
            boxShadow: "2px 2px 19px rgba(0, 0, 0, 0.2)",
            padding: "30px",
            boxSizing: "border-box",
          }}
        >
          <h3 className="text-center mb-4">Create Your New Password</h3>

          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label htmlFor="newPass" className="form-label">
                New Password
              </label>
              <div
                style={{ position: "relative" }}
                className="password-input-container"
              >
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  onChange={handleInputChange}
                  value={password}
                  className="form-control py-2"
                  minLength="8"
                  maxLength="18"
                  pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$"
                  title="Confirm Password must be at least 8 characters with uppercase, lowercase, number, and special character"
                  id="newPass"
                  name="password"
                  required
                />
                <div
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                  }}
                  className="password-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <IoMdEyeOff /> : <IoMdEye />}
                </div>
              </div>
            </div>

            <div className="mb-3">
              <label htmlFor="confPass" className="form-label">
                Confirm Password
              </label>
              <div
                style={{ position: "relative" }}
                className="password-input-container"
              >
                <input
                  type={showPassword2 ? "text" : "password"}
                  placeholder="Confirm Password"
                  onChange={handleInputChange}
                  value={confirm_password}
                  className="form-control py-2"
                  id="confPass"
                  name="confirm_password"
                  required
                />
                <div
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                  }}
                  className="password-toggle"
                  onClick={() => setShowPassword2(!showPassword2)}
                >
                  {showPassword2 ? <IoMdEyeOff /> : <IoMdEye />}
                </div>
              </div>
              {mess && <p style={{ color: "red", marginTop: "8px" }}>{mess}</p>}
            </div>

            <div className="d-flex justify-content-center mt-4">
              <Button
                type="submit"
                style={{
                  background: "#286a94",
                  width: "100%",
                  fontSize: "1rem",
                  boxShadow: "none",
                  padding: "10px",
                }}
                variant="contained"
              >
                Continue
              </Button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default NewPassword;
